import FaqItem from "./FaqItem";

import { InfoAlert } from "./styles";
import closeIcon from "./imgs/close-icon.svg";
import headerImg from "./imgs/your-stay-banner.webp";
import hotelImg from "./imgs/hotel.png";
import arrivalImg from "./imgs/arrival.png";
import localCuisineImg from "./imgs/local-cuisine.png";
import redCarpetImg from "./imgs/the-red-carpet.png";
import departureImg from "./imgs/departure.png";
import niceToKnowImg from "./imgs/nice-to-know.png";

const YourStay = ({ onClose, eventName }) => {
  const hotelDetails = {
    name: "Hôtel Barrière Le Majestic Cannes",
    image: hotelImg,
    address: "10 Boulevard de La Croisette\n06400 Cannes"
  };

  const FAQS = [
    {
      category: "Accommodation",
      sectionHotel: hotelDetails,
      questions: [
        {
          question: "What costs are included in my accommodation?",
          answer: "Room, applicable taxes (VAT), breakfast, Wi-Fi."
        },
        {
          question: "What transportation is included in the program?",
          answer:
            "Transportation to/from arrival point, as well as to/from all organised activities."
        },
        {
          question: "How do I get around on site?",
          answer: "Mastercard will organise all your transport."
        }
      ]
    },
    {
      category: "Arrival",
      sectionImage: arrivalImg,
      questions: [
        {
          question: "What is the check-in and check-out time?",
          answer:
            "At the Majestic Barriere Hotel in Cannes upon arrival, another Mastercard hostess will welcome you at a Mastercard dedicated welcome desk in the lobby of the Hotel Majestic. To avoid queueing, a precheck-in will be made for you before your arrival. Your room might not be ready in case of early arrival. If this is the case, we thank you for your understanding.\n\nAt your arrival, you will receive an Official Festival de Cannes welcome pack, containing booklets, brochures and programs with all the information on what-is up at the Cannes Film Festival.\n\nYou will also get the specific documents offered by Mastercard: the official Accreditation that will enable you to visit the entire Cannes Film Festival and the Cannes Film Market, Lanyard and a pass to Mastercard dedicated areas"
        },
        {
          question: "Access Badge",
          answer:
            "Attention, the badges you receive with your hotel key must be worn at all time for security reasons, except on the red carpet. Your badge is key to your venue to Cannes, please don't lose it, it will be impossible for us to duplicate it.\n\nThe badges are not exchangeable. Please be aware that the official Festival du Film de Cannes Security Guards are highly trained and check all data at all check points."
        }
      ]
    },
    {
      category: "Emergency services numbers",
      questions: [
        {
          question:
            "What is the phone number of the emergency service in Cannes?",
          answer: "Police, Fire, Medical: 112"
        }
      ]
    },
    {
      category: "Exclusive Activities",
      questions: [
        {
          question: "What exclusive activities are planned in Cannes?",
          answer:
            "Mastercard has arranged an array of exclusive activities and experiences curated to enhance your time in Cannes. Prepare to embark on a journey of unparalleled indulgence and refinement as we present to you the highlights of your Cannes Film Festival experience."
        }
      ]
    },
    {
      category: "Local Cuisine",
      sectionImage: localCuisineImg,
      questions: [
        {
          question: "Le Majestic",
          answer:
            "For a delightful start to your day, breakfast will be provided at the Majestic, where you can relish in a selection of fresh fruit, French croissants, and other delectable delights. Your morning indulgence is sure to set the perfect tone for the day ahead."
        },
        {
          question: "Exclusive Locations",
          answer:
            "The menus of our exclusive locations have been meticulously crafted and personalised by our team in collaboration with the chefs to enchant your taste buds.\n\nAt the restaurants, you have the freedom to explore other dishes outside of Mastercard special menu. However, kindly be advised that any supplementary costs incurred will be charged directly by the restaurant upon conclusion of your meal.\n\nIf you feel venturesome, you can also choose another of the many exquisite restaurants in Cannes, at your own expense."
        }
      ]
    },
    {
      category: "The Event",
      sectionImage: redCarpetImg,
      questions: [
        {
          question: "The event",
          answer:
            "Cannes' great sport is celebrity spotting and the best place for this is by the Red-Carpet entrance to the Palais des Festivals, where you can see the stars of the movies programmed your night. This is the part of the festival that draws the most media and public attention.\n\nThe Red Carpet is not open to the public, it is invitation only.\n\nAs one of the main partners, Mastercard invites you to participate to this Priceless event and walk among the biggest celebrities on the famous steps before attending an exclusive screening of a film at the Palais des Festival."
        },
        {
          question: "Dress Code",
          answer:
            "Please note that men and women are required to bring or source their own tuxedo to attend the Red Carpet. It's important to adhere to the dress code, as failure to do so may result in denial of access to the Red Carpet event.\n\nThe legendary Red Carpet event is a high-profile, media-covered occasion that comes with its very own etiquette. To celebrate the work of art of the artists and film crews, attendees are kindly asked to dress appropriately for the gala event.\n\nMen are required to wear a black tuxedo, white shirt, black bow tie, black tuxedo belt, black shoes and black socks.\n\nWomen may wear an evening dress, a cocktail dress, dark-coloured suit, a dressy top with black trousers, a black dress, a black or midnight blue suit with bow tie.\n\nElegant shoes with or without heels are required. Trainers are not permitted.\n\nPlease, don't forget to bring your attire as specified."
        },
        {
          question: "Make-up & Hairstyling",
          answer:
            "On the day of the Red Carpet, the talents of our hairdresser and make-up artist will be available upon request. The participation fee for this private session is 350 EUR.\n\nThe beauty session will take place in your hotel room at a specific time given to you by our team during your check-in.\n\nDo not miss your appointment, we will not be able to reschedule it.\n\nPlease be sure to be dressed for the red carpet at this time to make the professionals' work easier."
        },
        {
          question: "On the Red Carpet",
          answer:
            "Prior to the Red Carpet, guests are kindly requested to gather at the Mastercard exclusive Lounge near the lobby of the Majestic. Here, you will have the opportunity to relax and enjoy the company of fellow Mastercard guests before the grand event.\n\nDuring this time, you will also receive your tickets for the movie screening and additional information to ensure that you make the most of this unforgettable experience.\n\nWhen the time comes, our team will escort you to a waiting limousine, which will transport you to the venue. We kindly ask that you carefully follow the instructions provided by our Red Carpet Team to ensure a seamless experience.\n\nOnce on the Red Carpet, our professional photographer will capture stunning images of you, ensuring that you have a cherished memento of this extraordinary event.\n\nPlease note that taking pictures with your own phone is strictly forbidden during the Red Carpet."
        }
      ]
    },
    {
      category: "Departure",
      sectionImage: departureImg,
      questions: [
        {
          question: "Check out",
          answer:
            "Your check out should be done before 11:00 am at the reception of the hotel. It is at the check out that you will be kindly asked to pay for your possible extra's. You will also receive from Mastercard a little souvenir as a goodbye present."
        },
        {
          question: "Transfer to the Airport",
          answer:
            "A Mastercard car will take you back to the airport in time to get your flight back home. The planning has been done in such a way to allow you to catch your plane safely and on time, even in case of unforeseen events such as traffic jams. Trust our team on this, they have many years of experience. You might think to be a bit early at the airport, but you will be there on time and without stress.\n\nOur goal is to make sure that you fly back home with a suitcase full of wonderful memories to share and relish with everyone."
        }
      ]
    },
    {
      category: "Nice to Know",
      sectionImage: niceToKnowImg,
      questions: [
        {
          question: "79th CANNES FILM FESTIVAL 2026",
          answer:
            "Every year, for 12 days in May, this small town on France's glitzy Cote d'Azur becomes the center of the cinematic universe, with more than 30,000 producers, distributors, directors, publicists, stars and hangers-on coming to buy, sell or promote more than 2,000 films. As the premier film event of the year, the festival attracts around 4,000 journalists from around the world, ensuring a global spotlight on anyone with enough charisma or prestige to seize it.\n\nEver since its creation, the Festival de Cannes has remained faithful to its founding purpose: to draw attention to and raise the profile of films with the aim of contributing towards to the development of cinema, boosting the film industry worldwide and celebrating cinema at an international level."
        },
        {
          question: "Official Screening",
          answer:
            "The films selected at the Festival come from all around the world and are even considered exclusive in the media world, as no release date is known before the screening. Consequently, this attracts all movie stars from all over the world and gathers around 4,000 journalists from all over the world."
        },
        {
          question: "The Hotel",
          answer:
            "You will be staying in the most prestigious hotel in Cannes, the Majestic Barriere, in 294 rooms and 15 Majestic The Apartments. Rich decor of the Belle Epoque style in each of the Industry suites and each room features panoramic views.\n\nMost rooms have approximately 42 sq.m and some include one to three bedrooms, one living room, one or two bathrooms and a private terrace."
        },
        {
          question: "CANNES",
          answer:
            "Once a small fishing village, Cannes is now a glamorous center for world business and culture, attracting the rich and famous.\n\nNestled on the French Riviera in the south of France, Cannes is renowned for its elegant hotels, fine dining, Mediterranean climate, and diverse cultural scene. The city also hosts the Film Festival and the Games/Crowns International Festival of Creativity."
        },
        {
          question: "Le Carlton",
          answer:
            "Renowned as the Cote d'Azur's most iconic and modern landmark, this legendary palace hotel has hosted stars and celebrities from around the globe.\n\nUpon entering Le Carlton through one of two grand marble entrances, guests are warmly welcomed by the lobby's striking Belle Epoque decor and refined atmosphere."
        },
        {
          question: "Dress etiquette",
          answer:
            "You will currently work in a public environment highly covered by all sorts of international media. We expect that you look and fit the role under all circumstances.\n\nDuring your stay: You will be asked to sign a document clarifying Mastercard's required dress code. We also reserve the right not to provide services in which you don't fit the role."
        },
        {
          question: "Personal photo",
          answer:
            "You will be allowed to take your camera with you at each event as long as it is not considered media. Furthermore, at the Red Carpet and Premiere event, no photos are allowed."
        }
      ]
    }
  ];

  return (
    <InfoAlert>
      <div className="inner-container">
        <div className="img-container">
          <img src={headerImg} alt="header" />
          <h2>{"Your Stay"}</h2>
        </div>
        <div className="close-button" onClick={onClose}>
          <img src={closeIcon} alt="close" />
        </div>
        <div className="scroll-view">
          <div className="section">
            {eventName === "CANNES" ? (
              <p>
                {
                  "Find all information about the Cannes Film Festival and your stay with Mastercard."
                }
              </p>
            ) : (
              <p>
                {
                  "Find all information about the Monaco Grand Prix and your stay with Mastercard."
                }
              </p>
            )}
          </div>

          <div className="section">
            <div className="faq-container">
              {FAQS.map((faq, index) => (
                <FaqItem
                  eventName={eventName}
                  key={index}
                  {...faq}
                  isLast={index === FAQS.length - 1}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </InfoAlert>
  );
};

export default YourStay;
